import type { FormCompositionHook } from '@ipfabric/ui-components/utils/formSnippets/useFormComposition';

type Props = {
  formComposition: FormCompositionHook<'vendors'>;
};

export const VendorsApiSubTab = ({ formComposition }: Props) => {
  return (
    <div className='flex flex-col flex-1 gap'>
      {formComposition.renderGroup('vendors')}
    </div>
  );
};
